<section class="at-a-glance-panel">
  <div class="at-a-glance-header">
    <h2 class="at-a-glance-title">At-a-glance</h2>
    <mat-icon
      svgIcon="info"
      class="at-a-glance-info-icon at-a-glance-info-icon--interactive"
      cdkOverlayOrigin
      #infoOrigin="cdkOverlayOrigin"
      (mouseenter)="onInfoEnter()"
      (mouseleave)="onInfoLeave()"
      (click)="onInfoToggle()"
    ></mat-icon>
  </div>
  <cds-tooltip
    [origin]="infoOrigin"
    [open]="infoTooltipOpen"
    placement="left"
    [panelWidth]="256"
    [hasBackdrop]="false"
    (hovered)="onInfoEnter()"
    (unhovered)="onInfoLeave()"
  >
    <ng-template #tooltipContent>
      <div>{{ infoTooltipText }}</div>
    </ng-template>
  </cds-tooltip>

  <div class="at-a-glance-cards" [class.at-a-glance-cards--empty]="!notifications.length">
    <ng-container *ngIf="notifications.length; else emptyNotificationsState">
      <notification-card
        *ngFor="let item of notifications; trackBy: trackByStudySk"
        [item]="item"
        [showClientName]="showClientName"
      ></notification-card>
    </ng-container>

    <ng-template #emptyNotificationsState>
      <div class="at-a-glance-empty-state">
        <p class="at-a-glance-empty-title">No notifications</p>
        <p class="at-a-glance-empty-description">There are no new updates at this time</p>
      </div>
    </ng-template>
  </div>
</section>
